import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation"},[_c(VNavigationDrawer,{attrs:{"width":"14em","fixed":"","permanent":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('navigation-drawer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }